import Reveal from "./Reveal";
import { INSIGHTS_ARTICLES, INSIGHTS_HOME } from "../data/insights";

export default function InsightsBlock() {
  return (
    <section
      className="band band-deep"
      id="insights"
      data-testid="section-insights"
    >
      <div className="container insights-grid">
        <Reveal>
          <div>
            <p className="eyebrow">From Insights</p>
            <h2>How we think, in writing.</h2>
            <p className="insights-intro">
              Long form articles from the firm, published at{" "}
              <a
                className="insights-site-link"
                href={INSIGHTS_HOME}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="insights-site-link"
              >
                insights.globalcitizenconsult.com
              </a>
              .
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <ul className="insights-list" data-testid="insights-list">
            {INSIGHTS_ARTICLES.map((article) => (
              <li key={article.title}>
                <a
                  className="insights-item"
                  href={article.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="insights-article-link"
                >
                  <p className="insights-cat">{article.category}</p>
                  <h3 className="insights-title">{article.title}</h3>
                </a>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
